import {GetAppointmentAttachments} from 'domain/usecases';
import {RemoteGetAppointmentAttachments} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {BookedFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeGetAppointmentAttachments = (): GetAppointmentAttachments =>
	new RemoteGetAppointmentAttachments(
		makeBFFApiUrl(BookedFlowEndPoints.appointmentAttachments),
		makeAuthorizeHttpClientDecorator(),
	);
